import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import type { AppUserSession } from "~~/shared/types/session";
export default defineNuxtPlugin({
  dependsOn: ["session"],
  setup() {
    const config = useRuntimeConfig();
    if (!config.public.datadog.clientToken || import.meta.dev) return;

    const version = config.public.version;
    const sessionSampleRate = config.public.datadog.sessionSampleRate || 0;
    const sessionReplaySampleRate =
      config.public.datadog.sessionReplaySampleRate || 0;
    datadogLogs.init({
      clientToken: config.public.datadog.clientToken,
      site: "us3.datadoghq.com",
      forwardErrorsToLogs: true,
      forwardConsoleLogs: ["error", "warn", "info"],
      sessionSampleRate,
      service: "dealer-portal",
      env: config.public.datadog.env,
      version: `${version}`,
    });
    datadogRum.init({
      applicationId: config.public.datadog.rumApplicationId,
      clientToken: config.public.datadog.clientToken,
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: "us3.datadoghq.com",
      service: "dealer-portal",
      env: config.public.datadog.env,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: `${version}`,
      sessionSampleRate,
      sessionReplaySampleRate,
      defaultPrivacyLevel: "mask-user-input",
      allowedTracingUrls: [config.public.datadog.allowedTracingUrl],
    });

    const { session, hooks } = useAppSession();
    syncUser(session.value);
    hooks.hook("session-changed", syncUser);
  },
});

function syncUser(session: AppUserSession) {
  if (!session.user) {
    datadogLogs.clearUser();
    datadogRum.clearUser();
    return;
  }
  const ddUser = {
    id: session.user.id,
    email: session.user.email,
    name: session.user.displayName,
  };
  datadogLogs.setUser(ddUser);
  datadogRum.setUser(ddUser);
}
